import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { patienceDiff } from '../../../patienceDiff';

@Component({
  selector: 'app-html-note-diff',
  templateUrl: './html-note-diff.component.html',
  styleUrls: ['./html-note-diff.component.css']
})
export class HtmlNoteDiffComponent implements OnChanges, OnInit {

  @Input() oldNote: string = null
  @Input() newNote: string = null;

  added: string[] = [];
  removed: string[] = [];

  constructor() { }

  initDiff(){
    let oldNote = this.oldNote? this.oldNote.split(/<\/?(div|p|br)[^>]*>/igm).filter(x => x !== 'p' && x !== 'br' && x !== ''): [];
    let newNote = this.newNote? this.newNote.split(/<\/?(div|p|br)[^>]*>/igm).filter(x => x !== 'p' && x !== 'br' && x !== ''): [];
    let v = patienceDiff(oldNote, newNote, true);
    this.added = v.bMove;
    this.removed = v.aMove;
  }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    if(simpleChanges['oldNote'] || simpleChanges['newNote']) this.initDiff();
  }

  ngOnInit(): void {
    this.initDiff();
  }

}
